export const en = {
    'CollectionDefectIds.Gen.CANNOT_BE_EMPTY': 'No  "Search scope parameter selected"',
    'DefectIds.NO_RIGHTS': 'No authorization to perform this operation',
    'GdExceptions.ACCESS_DENIED': 'No authorization to view this page',
    'GdExceptions.NO_RIGHTS': 'No authorization to perform this operation',
    'GdExceptions.TYCOON_SERVICE_UNAVAILABLE':
        'Something went wrong. There was a problem getting data from Yandex Business Directory',
    'KeywordDefectIds.Gen.NO_RIGHTS_IN_ARCHIVED_ADGROUP':
        'Unable to replace words in archived ad groups: {validationResultValue}',
    'KeywordDefectIds.Keyword.MAX_KEYWORDS_PER_AD_GROUP_EXCEEDED': 'Maximum keywords per group reached:{maxKeywords}',
    'PhraseDefectIds.Gen.BOTH_QUOTES_AND_MINUS_WORDS': "A phrase in quotation marks can't consist of negative keywords",
    'PhraseDefectIds.Gen.INVALID_EXCLAMATION_MARK': 'Negative keywords contain invalid characters',
    'PhraseDefectIds.Gen.INVALID_MINUS_MARK': 'Negative keywords contain invalid characters',
    'PhraseDefectIds.Gen.INVALID_PLUS_MARK': "Keywords contain characters that aren't allowed",
    'PhraseDefectIds.Gen.NO_PLUS_WORDS': "Can't replace because the keyword is deleted completely",
    'PhraseDefectIds.String.ILLEGAL_CHARACTERS': 'Invalid characters entered: {allInvalidSubstrings}',
    'PhraseDefectIds.String.NOT_SINGLE_MINUS_WORD':
        'Only separate words (not phrases) can be negative in a keyword: {phrase}',
    'PhraseDefectIds.String.TOO_LONG_MINUS_WORD':
        'The maximum negative keyword length is {maxLength}. The negative keyword {allInvalidSubstrings} is too long.',
    'PhraseDefectIds.String.TOO_LONG_WORD':
        'The maximum keyword length is {maxLength}. The keyword "{allInvalidSubstrings}" is too long.',
    'PhraseDefectIds.String.TOO_MANY_WORDS': 'The maximum number of words in a keyword is {maxWords}',
    'StringDefectIds.CANNOT_BE_EMPTY': "Can't replace because the keyword is deleted completely",
    'phrase-only-stop-words': 'A keyword must consist of more than "stop words" (conjunctions, prepositions, etc.).',
    'unknown-error': 'Unexpected error',
    'unknown-error-title': 'Something went wrong'
};
